import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import configReducer from "./configSlice";
import loginReducer from "../login/loginSlice";
import langReducer from "../lang/langSlice";
import tokenReducer from "../tokenHandling/tokenSlice";
import appReducer from "../../stores/app/appSlice";
import pageAlertsReducer from "../../stores/alerts/alertsPageSlice";
import pageRecurrenceReducer from "../../stores/recurrence/recurrencePageSlice";
import pageNotificationsReducer from "../../stores/notifications/notificationsPageSlice";
import pageDowntimeReducer from "../../stores/downtime/downtimePageSlice";
import { truckApi } from "../../services/truckApi";
import { vehicleStatusApi } from "../../services/vehicleStatusApi";
import { dtcApi } from "../../services/dtcApi";
import { scheduleApi } from "../../services/scheduleApi";
import { downtimeApi } from "../../services/downtimeApi";

export const store = configureStore({
	reducer: {
		config: configReducer,
		lang: langReducer,
		app: appReducer,
		pageAlerts: pageAlertsReducer,
		pageDowntime: pageDowntimeReducer,
		pageNotifications: pageNotificationsReducer,
		pageRecurrence: pageRecurrenceReducer,
		login: loginReducer,
		tokenHandling: tokenReducer,
		[truckApi.reducerPath]: truckApi.reducer,
		[dtcApi.reducerPath]: dtcApi.reducer,
		[scheduleApi.reducerPath]: scheduleApi.reducer,
		[downtimeApi.reducerPath]: downtimeApi.reducer,
		[vehicleStatusApi.reducerPath]: vehicleStatusApi.reducer,
	},

	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware().concat(
			downtimeApi.middleware,
			truckApi.middleware,
			scheduleApi.middleware,
			dtcApi.middleware,
			vehicleStatusApi.middleware,
		),
});

export type RootState = ReturnType<typeof store.getState>;
export type RootDispatch = typeof store.dispatch;

setupListeners(store.dispatch);
